<template>
  <ValidationProvider v-slot="{ errors }">
    <div class="hm-toggle-button-group border">
      <div
        class="hm-toggle-button"
        :class="{
          'hm-toggle-button--false-active': !isTurnedOn,
          'hm-toggle-button--disabled': disabled,
        }"
      >
        <input
          type="checkbox"
          :checked="isTurnedOn"
          :disabled="disabled"
          v-model="isTurnedOn"
          @click="turnOff"
          @change="turnOff"
          class="hm-toggle-checkbox"
        />
        <slot name="falseState">
          <span>
            {{ $t('GENERAL.LABEL.OFF') }}
          </span>
        </slot>
      </div>
      <span :id="`error_${uid}`">{{ errors[0] }}</span>
      <div
        class="hm-toggle-button"
        :class="{
          'hm-toggle-button--active': isTurnedOn,
          'hm-toggle-button--disabled': disabled,
        }"
      >
        <input
          type="checkbox"
          :checked="isTurnedOn"
          :disabled="disabled"
          v-model="isTurnedOn"
          @click="turnOn"
          @change="turnOn"
          class="hm-toggle-checkbox"
        />
        <slot name="trueState">
          <span>
            {{ $t('GENERAL.LABEL.ON') }}
          </span>
        </slot>
      </div>
      <span :id="`error_${uid}`">{{ errors[0] }}</span>
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'HMToggleButtonGroup',
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isTurnedOn: this.value,
    };
  },
  computed: {
    uid() {
      return this._uid;
    },
  },
  methods: {
    turnOff() {
      if (this.disabled) {
        return;
      }
      this.isTurnedOn = false;
      this.$emit('change', this.isTurnedOn);
      this.$emit('input', this.isTurnedOn);
    },
    turnOn() {
      if (this.disabled) {
        return;
      }
      this.isTurnedOn = true;
      this.$emit('change', this.isTurnedOn);
      this.$emit('input', this.isTurnedOn);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.isTurnedOn = value;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
$height: 42px;
$padding: 2px;

.hm-toggle-button-group {
  height: $height;
  border-radius: $height / 2;
  display: flex;
  padding: $padding;
  white-space: nowrap;
  &--disabled {
    opacity: 0.5;
    cursor: default;
  }
}

.hm-toggle-button {
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
  user-select: none;

  min-width: $height - $padding * 2;
  border-radius: $height / 2 - $padding;
  padding: 0 0.75rem;

  &--active {
    background-color: var(--brand-color, $coral);
    color: white;
  }
  &--false-active {
    background-color: $medium-gray;
    color: $white;
  }
  &--disabled {
    opacity: 0.5;
    cursor: default;
  }
  &--on-empty {
    margin-left: -4px;
  }
}

.hm-toggle-checkbox {
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  top: 0;
  left: 0;
}
</style>
